import AiGenerativeRemoveIcon from '@atlaskit/icon-lab/core/ai-generative-remove';
import * as React from 'react';

export function SvgFillerWordRemoval() {
  return <AiGenerativeRemoveIcon label="" testId="ads-refreshed-icon" />;
}
